<h1 mat-dialog-title>Approval note</h1>
<div mat-dialog-content class="test">
  <iframe [src]="previewSrc" width="100%" height="100%" title="'hello'">
  </iframe>
</div>
<mat-dialog-actions align="end" class="dg-btn">
  <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
